import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import validate from './OrgUnitAdminCredentialsSelectionValidation';

import NavLinks from '../../../meet/NavLinks';
import EntryNavLinks from '../../EntryNavLinks';

import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';
import useOmeMeetOrgUnitEntryData from '../../../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useOmeMeetOrgUnitNonAthleteEntryData from '../../../../state/omeMeetOrgUnitNonAthleteEntry/UseOmeMeetOrgUnitNonAthleteEntryData';
import useOmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData from '../../../../state/omeMeetOrgUnitNonAthleteEntryCredentialsSelection/UseOmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData';
import useCredentialTypeData from '../../../../state/credentialType/UseCredentialTypeData';

import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';
import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

import UseForm from '@usas/ui-web/utils/UseForm';
import Constants from '@usas/ui-web/utils/Constants';

const INITIAL_FORM_STATE = {
  credentialTypeId: Constants.DEFAULT_ID,
  credentialTypeName: '',
  massageTypeName: '',
  isInGoodStanding: true,
  firstOrPreferredName: '',
  lastName: '',
  memberId: '',
  email: ''
};

const useOrgUnitAdminCredentialsSelection = () => {
  const navigate = useNavigate();
  const { omeMeetState } = useOmeMeetData()
  const { omeMeetOrgUnitEntryState } = useOmeMeetOrgUnitEntryData();
  const { omeMeetOrgUnitNonAthleteEntryState } = useOmeMeetOrgUnitNonAthleteEntryData();
  const { omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState,
    getOrgUnitNonAthleteEntryCredentialsSelection, postOrgUnitNonAthleteEntryCredentialsSelection } = useOmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData();
  const { credentialTypeState } = useCredentialTypeData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
  const [state, setState] = useState({
    isInitialLoadComplete: false, tryFilter: false, tryRedirect: false,
    currentFilterResultsCredentialTypeId: Constants.DEFAULT_ID, currentFilterResultsCredentialTypeName: ''
  });
  const [gridState, setGridState] = useState({ gridData: [] });
  const [selectionChangesState, setSelectionChangesState] = useState({ arrayData: [] });
  const { handleSubmit, formState, errorState, setErrors, setFormState, onFormValueChanged, onValueTextPairChanged } = UseForm(INITIAL_FORM_STATE, submitFormCallback, validate);
  const { environmentVariableState, CREDENTIAL_TYPE_NAME_MASSAGE } = useEnvironmentVariableData();

  const onFilterClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    handleSubmit();
  }

  const onClearFilterClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (state.currentFilterResultsCredentialTypeId !== credentialTypeState.dataAsOptionsWithNames[1]?.id) {
      setSelectionChangesState({ ...selectionChangesState, arrayData: [] });
    }
    let newFormState = {
      ...INITIAL_FORM_STATE,
      credentialTypeId: credentialTypeState.dataAsOptionsWithNames[1]?.id || Constants.DEFAULT_ID,
      credentialTypeName: credentialTypeState.dataAsOptionsWithNames[1]?.name || '',
      massageTypeName: CREDENTIAL_TYPE_NAME_MASSAGE || ''
    }
    setFormState(newFormState);
    setState({ ...state, currentFilterResultsCredentialTypeId: newFormState.credentialTypeId, currentFilterResultsCredentialTypeName: newFormState.credentialTypeName });
    getOrgUnitNonAthleteEntryCredentialsSelection(omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId, createFilterObj(newFormState));
    setErrors({});
  }

  const onSaveClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    let deleteAfterPayment = false;
    //checking for delete if the team is attached and has submitted, or if the team is unattached
    if (omeMeetOrgUnitEntryState.objData.status !== Constants.WORKFLOW_STATUS_IN_PROGRESS) {
      for (let i = 0; i < selectionChangesState.arrayData.length; i++) {
        if (selectionChangesState.arrayData[i].orgUnitNonAthleteEntryId !== null && selectionChangesState.arrayData[i].isSelected === false &&
          selectionChangesState.arrayData[i].hasPaid === true) {
          deleteAfterPayment = true;
        }
      }
    }

    if (deleteAfterPayment === true) {
      setErrors({ ...errorState, general: `The current selections removed a paid credential. Removing a credential that has been purchased is not allowed.` });
    }
    else {
      let deckPassRuleError = false;
      //Compare maxCredentialNumber to number of selections
      if (omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber !== undefined &&
        omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber !== null &&
        omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber >= 0) {
        let existingCredentialNum = omeMeetOrgUnitNonAthleteEntryState.arrayData?.length;
        let newSelectionsArray = selectionChangesState.arrayData?.filter(x => (x.isSelected === true && x.orgUnitNonAthleteEntryId === null));
        let newSelectionsNum = newSelectionsArray ? newSelectionsArray.length : 0;
        let newUnselectionsArray = selectionChangesState.arrayData?.filter(x => (x.isSelected === false && x.orgUnitNonAthleteEntryId !== null));
        let newUnselectionsNum = newUnselectionsArray ? newUnselectionsArray.length : 0;
        let newCredentialNum = existingCredentialNum + newSelectionsNum - newUnselectionsNum;
        if (newCredentialNum > omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber) {
          if (omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.credentialsCanBeAddedAfterCap === true) {
            //Check to see if all the new additions are massage credentials
            if (state.currentFilterResultsCredentialTypeName !== CREDENTIAL_TYPE_NAME_MASSAGE) {
              let existingNonMassageCredentialArray = omeMeetOrgUnitNonAthleteEntryState.arrayData?.filter(x => (x.typeName !== CREDENTIAL_TYPE_NAME_MASSAGE));
              let existingNonMassageCredentialNum = existingNonMassageCredentialArray ? existingNonMassageCredentialArray.length : 0;
              let newNonMassageCredentialNum = existingNonMassageCredentialNum + newSelectionsNum - newUnselectionsNum;
              if (newNonMassageCredentialNum > omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber) {
                deckPassRuleError = true;
              }
            }
          }
          else {
            deckPassRuleError = true;
          }
        }
      }
      if (deckPassRuleError === true) {
        setErrors({ ...errorState, general: `The current selections exceed the number of allowed credentials according to the meet's deck pass rules. With the current roster, ${omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber ?? ''} credential ${omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber === 1 ? 'selection is' : 'selections are'} allowed. ${omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.credentialsCanBeAddedAfterCap === true ? 'Only massage credentials can be added after the cap has been reached.' : 'No credentials can be added after the cap has been reached.'}` });
      }
      else {
        if (selectionChangesState.arrayData.length > 0) {
          let allSelectionsInGoodStanding = true;
          for (let i = 0; i < selectionChangesState.arrayData.length; i++) {
            if (selectionChangesState.arrayData[i].isInGoodStanding === false && selectionChangesState.arrayData[i].isSelected === true) {
              allSelectionsInGoodStanding = false
            }
          }
          if (allSelectionsInGoodStanding === true) {
            postOrgUnitNonAthleteEntryCredentialsSelection(omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId, {
              maxCredentialNumber: omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber,
              members: selectionChangesState.arrayData
            },
              state.currentFilterResultsCredentialTypeId);
            setState({ ...state, tryRedirect: true });
          }
          else {
            setErrors({ ...errorState, general: "All selections must be 'In Good Standing'. At least one selection is 'Not In Good Standing', which is not allowed." })
          }
        }
        else {
          setState({ ...state, tryRedirect: true });
        }
      }
    }
  }

  const onBackClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (omeMeetState.route === '') {
      //OME Route
      navigate(EntryNavLinks.OU_ADMIN_CREDENTIALS);
    }
    else {
      //Meet Route
      navigate(NavLinks.OU_ADMIN_CREDENTIALS);
    }
  }

  const onSelectAll = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    const updatedArrayData = JSON.parse(JSON.stringify(selectionChangesState.arrayData));
    const updatedGridData = JSON.parse(JSON.stringify(gridState.gridData));
    for (let i = 0; i < updatedGridData.length; i++) {
      if (updatedGridData[i].credentialEntered === false) {
        if (updatedGridData[i].hasPaid === false) {
          updatedGridData[i].isSelected = true;
        }
      }
      const selectedAthleteIndexArrayData = updatedArrayData.findIndex(x => x.personId === updatedGridData[i].personId);
      //Edit
      if (selectedAthleteIndexArrayData > -1) {
        if (updatedGridData[i].credentialEntered === false) {
          if (updatedArrayData[selectedAthleteIndexArrayData].hasPaid === false) {
            updatedArrayData[selectedAthleteIndexArrayData].isSelected = true;
          }
        }
      }
      else {
        updatedArrayData.push(updatedGridData[i]);
      }
    }

    setSelectionChangesState({
      ...selectionChangesState,
      arrayData: updatedArrayData
    });
    setGridState({ ...gridState, gridData: updatedGridData });
  }

  const onUnselectAll = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    const updatedArrayData = JSON.parse(JSON.stringify(selectionChangesState.arrayData));
    const updatedGridData = JSON.parse(JSON.stringify(gridState.gridData));
    for (let i = 0; i < updatedGridData.length; i++) {
      if (updatedGridData[i].credentialEntered === false) {
        if (updatedGridData[i].hasPaid === false) {
          updatedGridData[i].isSelected = false;
        }
      }
      const selectedAthleteIndexArrayData = updatedArrayData.findIndex(x => x.personId === updatedGridData[i].personId);
      //Edit
      if (selectedAthleteIndexArrayData > -1) {
        if (updatedGridData[i].credentialEntered === false) {
          if (updatedArrayData[selectedAthleteIndexArrayData].hasPaid === false) {
            updatedArrayData[selectedAthleteIndexArrayData].isSelected = false;
          }
        }
      }
      else {
        updatedArrayData.push(updatedGridData[i]);
      }
    }

    setSelectionChangesState({
      ...selectionChangesState,
      arrayData: updatedArrayData
    });
    setGridState({ ...gridState, gridData: updatedGridData });
  };

  const onCheckboxChange = (e, personId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    const updatedArrayData = JSON.parse(JSON.stringify(selectionChangesState.arrayData));
    const selectedAthleteIndexArrayData = updatedArrayData.findIndex(x => x.personId === personId);

    const updatedGridData = JSON.parse(JSON.stringify(gridState.gridData));
    const selectedAthleteIndexGridData = gridState.gridData?.findIndex(x => x.personId === personId);

    if (selectedAthleteIndexArrayData > -1) {
      updatedArrayData[selectedAthleteIndexArrayData].isSelected = !updatedArrayData[selectedAthleteIndexArrayData].isSelected;
      setSelectionChangesState({
        ...selectionChangesState,
        arrayData: updatedArrayData
      });
    }

    if (selectedAthleteIndexGridData > -1) {
      updatedGridData[selectedAthleteIndexGridData].isSelected = !updatedGridData[selectedAthleteIndexGridData].isSelected;
      setGridState({
        ...gridState,
        gridData: updatedGridData
      });
    }
    if (selectedAthleteIndexArrayData === -1) {
      const newAthlete = JSON.parse(JSON.stringify(updatedGridData[selectedAthleteIndexGridData]));
      updatedArrayData.push(newAthlete);
      setSelectionChangesState({
        ...selectionChangesState,
        arrayData: updatedArrayData
      });
    }
  };

  function submitFormCallback(formState) {
    if (state.currentFilterResultsCredentialTypeId !== formState.credentialTypeId) {
      setSelectionChangesState({ ...selectionChangesState, arrayData: [] });
    }
    setState({ ...state, currentFilterResultsCredentialTypeId: formState.credentialTypeId, currentFilterResultsCredentialTypeName: formState.credentialTypeName });
    getOrgUnitNonAthleteEntryCredentialsSelection(omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId, createFilterObj(formState));
  }

  function createFilterObj(formState) {
    return {
      credentialTypeId: formState.credentialTypeId !== Constants.DEFAULT_ID ? formState.credentialTypeId : undefined,
      isInGoodStanding: formState.isInGoodStanding ?? undefined,
      firstName: formState.firstOrPreferredName.trim() !== '' ? formState.firstOrPreferredName.trim() : undefined,
      lastName: formState.lastName.trim() !== '' ? formState.lastName.trim() : undefined,
      memberId: formState.memberId.trim() !== '' ? formState.memberId.trim() : undefined,
      email: formState.email.trim() !== '' ? formState.email.trim() : undefined
    }
  }

  function selectionsHaveBeenSaved() {
    //see if selection changes have been saved
    if (selectionChangesState.arrayData.length > 0) {
      return false;
    }

    return true;
  }

  useEffect(() => {
    const isSaved = selectionsHaveBeenSaved();
    setLeftNavModalState({ ...leftNavModalState, formStateSaved: isSaved });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionChangesState.arrayData]);

  useEffect(() => {
    if (environmentVariableState.isLoaded === true, credentialTypeState.isArrayLoading === false &&
      credentialTypeState.isArrayLoaded === true && formState.credentialTypeId === Constants.DEFAULT_ID &&
      state.isInitialLoadComplete === false) {
      setFormState({
        ...formState,
        credentialTypeId: credentialTypeState.dataAsOptionsWithNames[1]?.id || Constants.DEFAULT_ID,
        credentialTypeName: credentialTypeState.dataAsOptionsWithNames[1]?.name || '',
        massageTypeName: CREDENTIAL_TYPE_NAME_MASSAGE || ''
      });
      setState({ ...state, isInitialLoadComplete: true, tryFilter: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [environmentVariableState, credentialTypeState, formState.credentialTypeId, state.isInitialLoadComplete])

  useEffect(() => {
    if (omeMeetOrgUnitEntryState.isObjLoaded === true && omeMeetOrgUnitEntryState.objData?.omeMeetOrgUnitEntryId &&
      state.tryFilter === true) {
      setState({ ...state, tryFilter: false, currentFilterResultsCredentialTypeId: formState.credentialTypeId, currentFilterResultsCredentialTypeName: formState.credentialTypeName });
      getOrgUnitNonAthleteEntryCredentialsSelection(omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId, createFilterObj(formState));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitEntryState, state.tryFilter])

  useEffect(() => {
    if (omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.isArrayLoaded === true && omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.isArrayLoading === false) {
      const arrayDataCopy = JSON.parse(JSON.stringify(omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.members || []));
      //keep unsaved selections / unselections from previous searches
      if (selectionChangesState.arrayData.length > 0) {
        for (let i = 0; i < selectionChangesState.arrayData.length; i++) {
          const matchingIndex = arrayDataCopy.findIndex(x => x.personId === selectionChangesState.arrayData[i].personId);
          if (matchingIndex > -1) {
            arrayDataCopy[matchingIndex].isSelected = selectionChangesState.arrayData[i].isSelected;
          }
        }
      }
      setGridState({ ...gridState, gridData: arrayDataCopy });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.isArrayLoaded, omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.isArrayLoading])

  useEffect(() => {
    if (state.tryRedirect === true && omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.isSaving === false &&
      omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.isSaved === true) {
      if (omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.objData?.success === true) {
        if (omeMeetState.route === '') {
          //OME Route
          navigate(EntryNavLinks.OU_ADMIN_CREDENTIALS, { state: { tryGet: selectionChangesState.arrayData.length > 0 ? true : false } });
        }
        else {
          //Meet Route
          navigate(NavLinks.OU_ADMIN_CREDENTIALS, { state: { tryGet: selectionChangesState.arrayData.length > 0 ? true : false } });
        }
      }
      else {
        setErrors({ ...errorState, general: `The current selections exceed the number of allowed credentials according to the meet's deck pass rules. With the current roster, ${omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber ?? ''} credential ${omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber === 1 ? 'selection is' : 'selections are'} allowed. ${omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState.arrayData?.credentialsCanBeAddedAfterCap === true ? 'Only massage credentials can be added after the cap has been reached.' : 'No credentials can be added after the cap has been reached.'}` });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tryRedirect, omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState])

  return {
    gridState,
    omeMeetOrgUnitNonAthleteEntryCredentialsSelectionState,
    credentialTypeState,
    onSelectAll,
    onUnselectAll,
    onSaveClicked,
    onBackClicked,
    onCheckboxChange,
    onFilterClicked,
    onClearFilterClicked,
    onFormValueChanged,
    onValueTextPairChanged,
    formState,
    errorState,
    omeMeetOrgUnitEntryState
  };
}

export default useOrgUnitAdminCredentialsSelection;